import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { SkillSuggestionsResult, SkillSuggestionsState } from './skill-suggestions.type';

export const emptySkillSuggestionsResult = (): SkillSuggestionsResult => ({
  knowledgeDisciplines: [],
  technologiesMachines: [],
});

export const useSkillSuggestionsStore = defineStore('skill-suggestions', () => {
  const state = ref<SkillSuggestionsState>('idle');
  // Fingerprint of the job content the current state/result was produced for.
  const fingerprint = ref<string | null>(null);
  const result = ref<SkillSuggestionsResult>(emptySkillSuggestionsResult());
  const activeRunId = ref(0);
  const cancelWait = ref<(() => void) | null>(null);

  function reset() {
    state.value = 'idle';
    fingerprint.value = null;
    result.value = emptySkillSuggestionsResult();
    activeRunId.value += 1;
    cancelWait.value?.();
    cancelWait.value = null;
  }

  return { state, fingerprint, result, activeRunId, cancelWait, reset };
});
